import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { numberWithComma, truncateNumber } from "@/helper/formatter";

type Props = {
  count: number;
  sign?: string;
  unit: string;
  title: string;
  icon: IconProp;
};

const DashboardCard: React.FC<Props> = ({ count, sign, unit, icon, title }) => {
  const unitSign = sign ? sign : "";

  return (
    <li className="dashboard__item">
      <span className="dashboard__icon">
        <FontAwesomeIcon icon={icon} />
      </span>
      <div className="dashboard__info">
        <p className="dashboard__title body">
          {title}
          <span
            data-count={unitSign + numberWithComma(count)}
            className="dashboard__icon--1"
          >
            <FontAwesomeIcon icon={["fas", "info-circle"]} />
          </span>
        </p>
        <p className="dashboard__unit tiny">單位：{unit}</p>
        <p className="dashboard__value">
          {unitSign}
          {truncateNumber(count)}
        </p>
      </div>
    </li>
  );
};

export default DashboardCard;
